import { UtilService } from './../../../shared/services/util.service';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { AuthenticationService } from '@app/shared/services';
import { AcompanhamentoService } from '@app/shared/services/acompanhamento.service';
import { RedirectService } from '@app/core/services/redirect.service';
import { MensagemService } from '@app/shared/services/mensagem.service';

import { environment } from '@environments/environment';
import { Subscription, combineLatest } from 'rxjs';

import { Loading, Status, Historico, Censo } from '@app/shared/models';
import { ModalAvaliarAtendimentoComponent } from './modal-avaliar-atendimento/modal-avaliar-atendimento.component';
import { CensoService } from '@app/shared/services/censo.service';

@Component({
  selector: 'app-acompanhamento',
  templateUrl: './acompanhamento.component.html',
  styleUrls: ['./acompanhamento.component.scss']
})
export class AcompanhamentoComponent implements OnInit {

  carregar = new Loading();
  cliente = environment.cliente;
  seguradoInformacoes: any = this.auth.currentUserValue;

  historicos: Historico[] = [];
  status: Status;

  mostrarImpressaoComprovante: boolean;
  avaliacaoRealizada: boolean = false;

  private subscription: Subscription;

  censo: Censo;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private auth: AuthenticationService,
    private acompanhamentoService: AcompanhamentoService,
    private redirectService: RedirectService,
    private mensagemService: MensagemService,
    private utilService: UtilService,
    private censoService: CensoService
  ) {
    this.censo = this.censoService.retornarSessionStorage('censo');
    this.moverParaURLCorreta();

    combineLatest([
      this.acompanhamentoService.historicos(this.carregar),
      this.acompanhamentoService.status(this.carregar)
    ])
    .subscribe(([acompanhamento, status]) => {
      this.historicos = acompanhamento;
      this.status = status;

      this.verificarImpressaoComprovante(status);
    });
  }

  ngOnInit(): void {
    this.subscription = this.acompanhamentoService
      .buscarAvaliacaoAtendimento()
      .subscribe((status) => {
        if (!status) {
          this.subscription = this.acompanhamentoService
            .getStatusAvaliacao()
            .subscribe((status) => {
              this.avaliacaoRealizada = status;
            });
        } else {
          this.avaliacaoRealizada = status;
        }
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  logout(): void {
    this.mensagemService.avisoMensagemCondicional('', 'Você deseja realmente sair?', 'warning')
    .then((response) => {
      if (response.value) {
        this.auth.logout();
        this.router.navigate(['/']);
      }
    });
  }

  tratarFlagHistorico(flag: string): any {
    switch (flag) {
      case 'ERROR':
        return { classe: 'CheckListItem__Icon--error', icone: 'fa fa-times' };
      case 'SUCESSO':
        return { classe: 'CheckListItem__Icon--success', icone: 'fa fa-check' };
      default:
        return { classe: '', icone: 'fa fa-info' };
    }
  }

  formatarData(data: string | Date): string {
    return this.utilService.formatarDataLonga(data)
  }

  moverParaURLCorreta(): void {
    this.redirectService.verificarEtapa(this.carregar).subscribe(([status, etapa]) => {
      if (status.documentosRejeitados?.length > 0 || status.identificacoesRejeitadas?.length > 0) {
        if (status.identificacoesRejeitadas?.length > 0) {
          this.redirectService.redirecionar(true, null, true);
        } else {
          this.redirectService.redirecionar(true, null, false);
        }
      } else {
        this.redirectService.redirecionar(false, etapa);
      }
    });
  }

  imprimirComprovante(): void {
    this.acompanhamentoService.imprimirComprovante(this.carregar).subscribe(pdf => {
      const nav = (window.navigator as any);

      if (nav && nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(pdf);
      } else {
        const objectUrl = URL.createObjectURL(pdf);
        window.open(objectUrl);
      }
    });
  }

  verificarImpressaoComprovante(status: Status): void {
    switch (status.status) {
      case 'CONCLUIDO':
      case 'ATUALIZACAO_INICIADA':
      case 'ATUALIZACAO_CONCLUIDA':
      case 'REVISAO_INICIADA':
      case 'REVISAO_CONCLUIDA':
        this.mostrarImpressaoComprovante = true;
        break;
      default:
        this.mostrarImpressaoComprovante = false;
        break;
    }
  }

  abrirModalAvaliacao() {
    const dialogRef = this.dialog.open(ModalAvaliarAtendimentoComponent, {
      width: '500px',
      data: this.seguradoInformacoes
    });
  }
}
